import styled from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

export interface IJackpotWidgetAmountContainerProps {
    layout: JACKPOT_WIDGET_LAYOUT;
}

const JackpotWidgetAmountContainerDefaultBox = styled.div<IJackpotWidgetAmountContainerProps>`
    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE ? "40%" : "initial"};
`;

const JackpotWidgetAmountContainerMrGreenBox = styled(JackpotWidgetAmountContainerDefaultBox)`
    padding-bottom: 25%;
`;

export const JackpotWidgetAmountContainer = styledByTheme(JackpotWidgetAmountContainerDefaultBox)
    .forMrGreen(JackpotWidgetAmountContainerMrGreenBox)
    .forMrGreenCip(JackpotWidgetAmountContainerMrGreenBox)
    .forMrGreenCis(JackpotWidgetAmountContainerMrGreenBox)
    .apply();